import { createContext } from 'react';

export const AppraisersProfileContext = createContext(undefined);
export const AppraisersProfileProvider = AppraisersProfileContext.Provider;
